import script from "./UserRegister.vue?vue&type=script&setup=true&lang=js"
export * from "./UserRegister.vue?vue&type=script&setup=true&lang=js"

import "./UserRegister.vue?vue&type=style&index=0&id=6eae63ce&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6eae63ce"]])

export default __exports__